//The parent component, a literal container for Channels List and Channels View

import { RouteComponentProps, withRouter } from 'react-router-dom';
import React, { useEffect } from 'react';

import { useStyles } from '../styles';
import ChannelViewContainer from '../../Containers/Channels/ChannelViewContainer';
import ChannelsListContainer from '../../Containers/Channels/ChannelsListContainer';
import Grid from '@material-ui/core/Grid';

export interface IAppProps extends RouteComponentProps {
    history: any;
    channels: any;
    setChannelActive: Function;
}

const Channels = (props: IAppProps) => {
    const { channels, setChannelActive } = props;
    const classes = useStyles();
    useEffect(() => {
        //To make first channel active on component mount
        if (channels.length) setChannelActive(channels[0]['id']);
    }, [channels, setChannelActive]);
    return (
        <React.Fragment>
            <Grid className={classes.contentWrapper} container justify="space-between" spacing={3}>
                <ChannelsListContainer />
                {channels.length > 0 && <ChannelViewContainer />}
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(Channels);
